module.exports = __webpack_public_path__ + "2ece119c2bcde4c2381f70042250534e.png";